import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Container, Row, Col } from 'react-bootstrap';
import { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";

import { Button, Modal } from "react-bootstrap";
import Login from './Login';
// import Login from './LoginComponents/Login';


export default function KwdcHeader() {

    const [showLogin, setShowLogin] = useState(false);

    const handleClose = () => setShowLogin(false);
    const handleShow = () => setShowLogin(true);
    return (
        <>
            <Navbar expand="xl" className="fixed-top main-nav">
                <Container fluid className='nav-container-div '>
                    <Navbar.Brand as={NavLink} to="/homee"><div className='logo-part'>
                        <div className='kwdc-logo-part'>
                            <img src="../images/ap-logo.webp" className='img-fluid logo-part-img1' />
                            {/* <img src="../images/logo-line.png" className='img-fluid' /> */}
                            <div className='logo-line-section'></div>
                            <img src="../images/logo.webp" className='img-fluid logo-part-img2' />
                        </div>
                        <div className='kwdc-logo-heading'>
                            <h2>KAPU WELFARE AND DEVELOPMENT CORPORATION</h2>
                            <p>Government of Andhra Pradesh</p>
                        </div>

                    </div></Navbar.Brand>
                    <div className="d-flex align-items-center">
                        <Button
                            className="login-btn kwdc-login-btn"
                            onClick={handleShow}
                        >
                            Login
                        </Button>

                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    </div>
                    <Navbar.Collapse id="basic-navbar-nav ">
                        <Nav className="ms-auto nav-items-section kwdc-new-section">

                            <Nav.Link
                                as={NavLink}
                                to="/homee"
                                end
                                className={({ isActive }) => isActive ? "active" : ""}
                            >
                                Home
                            </Nav.Link>

                            <Nav.Link
                                as={NavLink}
                                to="/about"
                                className={({ isActive }) => isActive ? "active" : ""}
                            >
                                About
                            </Nav.Link>

                            <Nav.Link as={NavLink}
                                to="/TendersPage"
                                className={({ isActive }) => isActive ? "active" : ""}>Tenders</Nav.Link>

                            <Nav.Link as={NavLink}
                                to="/DownloadPage"
                                className={({ isActive }) => isActive ? "active" : ""}>Downloads</Nav.Link>

                            <Nav.Link as={NavLink}
                                to="/GalleryPage"
                                className={({ isActive }) => isActive ? "active" : ""}>Gallery</Nav.Link>

                            <Nav.Link as={NavLink}
                                to="/ContactPage"
                                className={({ isActive }) => isActive ? "active" : ""} >Contact</Nav.Link>

                        </Nav>
                        {/* <Button className='login-btn'>Login</Button> */}

                    </Navbar.Collapse>

                </Container>
            </Navbar>

            <Modal
                show={showLogin}
                onHide={handleClose}
                centered
                size="md"
                backdrop="static"
                contentClassName="kwdc-login-modal"   // ← add this line
            >
                <Modal.Header closeButton>
                    <Modal.Title>User Login</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Login />
                </Modal.Body>
            </Modal>
        </>
    )
}